/**
 * Shrink property list payloads before React state — production can still
 * return multi-MB base64 covers/floor plans until the light list API is deployed.
 */
export function lightenPropertyListItem(property, apiBase = "") {
  if (!property || typeof property !== "object") return property;

  const base = String(apiBase || "").replace(/\/+$/, "");
  const coverEndpoint = property.id ? `${base}/api/properties/${property.id}/cover` : null;

  const isHeavyMedia = (value) => {
    const text = String(value || "");
    if (!text) return false;
    return text.startsWith("data:") || text.length > 2048;
  };

  let coverImage = property.coverImage || property.image || null;
  if (!coverImage || isHeavyMedia(coverImage)) {
    coverImage = coverEndpoint || null;
  } else if (coverImage.startsWith("/api/") && base) {
    coverImage = `${base}${coverImage}`;
  }

  const {
    floorPlanImageUrl1,
    floorPlanImageUrl2,
    description,
    amenities,
    images,
    ...rest
  } = property;

  return {
    ...rest,
    coverImage,
    image: coverImage,
    imageCount: property.imageCount ?? (Array.isArray(images) ? images.length : undefined),
  };
}

export function lightenPropertyList(list, apiBase = "") {
  if (!Array.isArray(list)) return [];
  return list.map((item) => lightenPropertyListItem(item, apiBase));
}
